<template>
  <button
    type="button"
    class="toggle-btn"
    :class="{ 'active-color': !sectionVisible && newActiveColor }"
  >
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      :transform="sectionVisible ? 'rotate(0)' : 'rotate(180)'"
    >
      <path
        fill="currentColor"
        d="M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
      />
    </svg>
  </button>
</template>

<script type="text/javascript">
export default {
  name: "base-toggle-arrow-button",
  props: {
    sectionVisible: { type: Boolean, required: true },
    newActiveColor: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.toggle-btn {
  background: none;
  border: none;
  padding: 5px;
  cursor: pointer;
  color: #333;
  transition: color 0.2s ease, transform 0.2s ease;
}

.toggle-btn:hover {
  color: var(--color-dark);
}

.toggle-btn.active-color {
  color: #fff;
}

.toggle-btn svg {
  transition: transform 0.2s ease;
}
</style>
